import { PlatformUtility } from 'utility-ts-platform';
import { IStudyGroupDescription } from '../../study_group_interfaces';
import { StudyGroupsCapabilityConfiguration } from '../../study_groups_configuration';
import { StudyGroupModalService } from '../study_groups_modal_service';

export class StudyGroupDescriptionModalController {
  private isDesktop: boolean;
  private applyDesktopStyle?: true;
  private applyMobileStyle: boolean;
  private studyBuddiesValueList: IStudyGroupDescription[];
  constructor(
    private ngStudyGroupModalService: StudyGroupModalService,
    private ngStudyGroupsCapabilityConfiguration: StudyGroupsCapabilityConfiguration
  ) {
    this.studyBuddiesValueList = [
      {
        icon: 'edit',
        text: 'Help With Homework'
      },
      {
        icon: 'open_book',
        text: 'Study For Exams'
      },
      {
        icon: 'sync',
        text: 'Share Study Materials'
      }
      // ,{
      //   icon: 'smiley',
      //   text: 'Meet with Classmates'
      // }
    ];
  }

  $onInit() {
    this.isDesktop = PlatformUtility.isDesktop();
    this.applyDesktopStyle = !this.ngStudyGroupsCapabilityConfiguration.config.isMobile || undefined;
    this.applyMobileStyle = this.ngStudyGroupsCapabilityConfiguration.config.isMobile;
  }
  closeModal(): void {
    this.ngStudyGroupModalService.hideDescriptionModal();
  }
}

export class StudyGroupDescriptionModalComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-study-groups/src/modals/study_group_description_modal/study_group_description_modal.html';
  public controller: any = StudyGroupDescriptionModalController;
  public controllerAs: string = '$ctrl';
  public bindings = {
    opened: '='
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/modals/study_group_description_modal/study_group_description_modal.ts